import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Colors } from 'utils';
import ConfirmModal from './ConfirmModal';

/**
 * Schalter "Updates per E-Mail" fuer die Fusszeile einer Projektkachel im Profil.
 * Abschalten fragt vorher nach, Einschalten passiert sofort.
 * Farbe: aktuelles Plattform-Gruen (wie die gruenen Knoepfe).
 */
function UpdateMailToggle({ projectName, checked, disabled, onChange }) {
  const [confirming, setConfirming] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    if (checked) setConfirming(true);
    else onChange(true);
  };

  return (
    <>
      <Row>
        <span className="label" id={`update-mail-${projectName}`}>
          Updates per E-Mail
        </span>
        <Switch
          type="button"
          role="switch"
          aria-checked={checked}
          aria-labelledby={`update-mail-${projectName}`}
          disabled={disabled}
          $on={checked}
          onClick={handleClick}
        >
          <span className="knob" />
        </Switch>
      </Row>

      <ConfirmModal
        open={confirming}
        title="Keine Updates mehr per E-Mail?"
        text={`Du bekommst keine E-Mail mehr, wenn „${projectName}“ ein Update veröffentlicht. Du folgst dem Projekt weiterhin und siehst neue Updates auf der Projektseite.`}
        confirmLabel="Abbestellen"
        onCancel={() => setConfirming(false)}
        onConfirm={() => {
          setConfirming(false);
          onChange(false);
        }}
      />
    </>
  );
}

UpdateMailToggle.propTypes = {
  projectName: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default UpdateMailToggle;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-family: Inter, sans-serif;

  .label {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #414651;
  }
`;

const Switch = styled.button`
  position: relative;
  flex: 0 0 36px;
  width: 36px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: ${({ $on }) => ($on ? Colors.newSecondaryColor : '#d5d7da')};
  cursor: pointer;
  transition: background 0.15s ease;

  .knob {
    position: absolute;
    top: 2px;
    left: ${({ $on }) => ($on ? '18px' : '2px')};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(10, 13, 18, 0.2);
    transition: left 0.15s ease;
  }

  &:focus-visible {
    outline: 2px solid ${Colors.newSecondaryColor};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
